import { checkFileExists, getExternStat, getFileExternAgent, importFileExternalAgent } from "@core/actions/dashboardExterneAction.ts";
import { FetchStatusType } from "@core/modeles/model.ts";
import { RootState } from "@core/store/store.ts";
import { DashboardExternData } from "@modules/dashbord/dashbord.model.ts";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DashboardExterneState {
    loading: FetchStatusType;
    loadingImport: FetchStatusType;
    checkingFile: FetchStatusType;
    dataExtern:DashboardExternData | null;
    loadingExport: FetchStatusType;
    error: string | null;
}
const initialState: DashboardExterneState = {
    loading: FetchStatusType.IDLE,
    loadingImport: FetchStatusType.IDLE,
    checkingFile: FetchStatusType.IDLE,
    dataExtern: null,
    loadingExport: FetchStatusType.IDLE,
    error: null
}

const DashboardExterneSlice = createSlice({
    name: "dashboardExterne",
    initialState,
    reducers: {
        setDataExtern: (state, action: PayloadAction<DashboardExternData>) => {
            return { ...state, dataExtern: action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getExternStat.pending, (state) => {
                return { ...state, loading: FetchStatusType.LOADING };
            })
            .addCase(getExternStat.fulfilled, (state, action) => {
                return {
                    ...state,
                    loading: FetchStatusType.COMPLETED,
                    dataExtern: action.payload,
                }
            });
        builder
            .addCase(importFileExternalAgent.pending, (state) => {
                return { 
                    ...state,
                    loadingImport: FetchStatusType.LOADING
                }
            })
            .addCase(importFileExternalAgent.fulfilled, (state) => {
                return {
                    ...state,
                    loadingImport: FetchStatusType.COMPLETED,
                }
            })
            .addCase(importFileExternalAgent.rejected, (state) => {
                return {
                    ...state,
                    loadingImport: FetchStatusType.FAILED

                }
            })
        builder
            .addCase(getFileExternAgent.pending, (state) => {
                state.loadingExport = FetchStatusType.LOADING;
                state.error = null;
            })
            .addCase(getFileExternAgent.fulfilled, (state) => {
                state.loadingExport = FetchStatusType.COMPLETED;
            })
            .addCase(getFileExternAgent.rejected, (state, action) => {
                state.loadingExport = FetchStatusType.FAILED;
                state.error = action.payload as string;
            });
        builder
            .addCase(checkFileExists.pending, (state) => {
                return { 
                    ...state,
                    checkingFile: FetchStatusType.LOADING
                }
            })
            .addCase(checkFileExists.fulfilled, (state) => {
                return { 
                    ...state,
                    checkingFile: FetchStatusType.COMPLETED
                }
            })
            .addCase(checkFileExists.rejected, (state) => {
                return { 
                    ...state,
                    checkingFile: FetchStatusType.FAILED
                }
            })
    },
})

export const {setDataExtern} = DashboardExterneSlice.actions;
export const dashboardExterneData = (state: RootState) => state.dashboardExterne;
export const loadingImport = (state: RootState) => state.dashboardExterne.loadingImport;
export const checkingFile = (state: RootState) => state.dashboardExterne.checkingFile;
export const loadingExport = (state: RootState) => state.dashboardExterne.loadingExport;
export const loadingExternData = (state: RootState) => state.dashboardExterne.loading;

export default DashboardExterneSlice.reducer;